// components/Orders/riderStatus.js
// ─────────────────────────────────────────────────────────────────────────────
// A rider's online state, read the one way, for every "assign a rider"
// dropdown. The option label carries only the name; the state travels as the
// AppSelect badge (data-badge / data-badge-tone), drawn as a green or grey
// pill. Before this each page spelled the state into the label by hand
// ("Name || Offline", "Name — ONLINE") and a dispatcher had to read it out of
// the text.
// ─────────────────────────────────────────────────────────────────────────────

export const isRiderOnline = (rider) =>
  String(rider?.onlineStatus || "").trim().toUpperCase() === "ONLINE";

/** Spread onto the rider's <option>: the pill text and tone. */
export const riderBadgeProps = (rider) => ({
  "data-badge": isRiderOnline(rider) ? "Online" : "Offline",
  "data-badge-tone": isRiderOnline(rider) ? "online" : "offline",
});

export const riderName = (rider) =>
  [rider?.firstName, rider?.lastName].filter(Boolean).join(" ").trim() || "Rider";

/** Online riders first, each group alphabetical, so the dispatcher sees who
 *  can take the order before who cannot. */
export const sortRidersOnlineFirst = (riders) =>
  [...(riders || [])].sort((a, b) => {
    const d = Number(isRiderOnline(b)) - Number(isRiderOnline(a));
    return d !== 0 ? d : riderName(a).localeCompare(riderName(b));
  });
